/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetObservabilitySessionsUsageQueryParams = NonNullable<
  operations['getObservabilitySessionsUsage']['parameters']['query']
>;

export interface Input {
  apiVersion?: string;
  query?: GetObservabilitySessionsUsageQueryParams;
}

export async function getObservabilitySessionsUsage(
  { apiVersion, query }: Input = {},
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/usage/observability/sessions', {
    params: { query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
